export const FASTIGHETSMAP = 'fastighetsmap';
